import { render, staticRenderFns } from "./snoozed.vue?vue&type=template&id=369b5f00&"
import script from "./snoozed.vue?vue&type=script&lang=js&"
export * from "./snoozed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports